import $ from "jquery";
import Rails from "rails-ujs";
import "init";

window.jQuery = $;
window.$ = $;
Rails.start();
